import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import s from './TestPurpose.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialTestPurposeState } from '../../store/reducers/initialState';
import uuidv4 from 'uuid/v4';
import { useParams, Redirect, useHistory } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GoBack from '../WSAControls/GoBack/GoBack';
import classNames from 'classnames';
import { isRequired } from '../../utils';
import Cookies from 'js-cookie';
import OperationalSetupContentTemplate from '../OperationalSetup/OperationalSetupContentTemplate';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import uuid from 'uuid';
import { getUserProfileWidget, getTestPurpose } from '../../selectors/index';
import { describeTestPurposeThunk, saveTestPurposeThunk, setTestPurposeChangeThunk } from '../../store/actions/testPurposes';
const envName = process.env.REACT_APP_ENV_NAME_SHORT;

const TestPurpose = ({ intl }) => {
  let history = useHistory();
  const dispatch = useDispatch();

  let { testPurposeId } = useParams();

  let IsEdit = false;

  const userProfileWidgets = useSelector(state => getUserProfileWidget(state));
  const testPurpose = useSelector(state => getTestPurpose(state));

  const [localformErrors, setFormErrors] = useState({});

  const backUrl = '/operational-setup/test-results';
  let widgetCode = '';
  if (testPurposeId) {
    IsEdit = true;
    widgetCode = 'WQSP_TESTPURPOSES_EDIT';
  }

  useEffect(() => {
    if (testPurposeId) {
      dispatch(describeTestPurposeThunk(testPurposeId, widgetCode));
    }
  }, [describeTestPurposeThunk, testPurposeId]);

  //clean up
  useEffect(() => {
    return () => {
      dispatch(
        setTestPurposeChangeThunk({
          ...initialTestPurposeState.testPurpose
        })
      );
    };
  }, []);

  // Update redux store
  const setLocalTestPurpose = currentState => {
    dispatch(setTestPurposeChangeThunk(currentState));
  };

  //Saving
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = testPurpose.selectedTestPurpose;
    saveData.PerformDelete = false;
    saveData.IsEdit = IsEdit;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;

    if (!IsEdit) {
      saveData.TestPurposeId = 0;
      saveData.GuidIdentifier = uuidv4();
      widgetCode = 'WQSP_TESTPURPOSES_ADDNEW';
    }

    dispatch(saveTestPurposeThunk(saveData, widgetCode));
  };

  const validateInput = () => {
    let formErrors = {};
    let isValid = true;

    if (
      !testPurpose ||
      !testPurpose.selectedTestPurpose ||
      !testPurpose.selectedTestPurpose.Name ||
      isRequired(testPurpose.selectedTestPurpose.Name, 1)
    ) {
      formErrors.Name = intl.formatMessage({
        id: 'common.nameRequired',
        defaultMessage: 'Name is a mandatory field'
      });
      isValid = false;
    }

    setFormErrors(formErrors);

    return isValid;
  };

  //on control value change
  const onChange = e => {
    setLocalTestPurpose({
      ...testPurpose,
      selectedTestPurpose: { ...testPurpose.selectedTestPurpose, [e.target.name]: e.target.value }
    });
  };

  const cancelHandler = () => {
    history.push(backUrl);
  };

  let messageId = (testPurpose && testPurpose.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const testPurposeName = (testPurpose.selectedTestPurpose ? testPurpose.selectedTestPurpose.Name : '') || '';
  let heading = '';
  if (IsEdit) {
    heading = intl.formatMessage({ id: 'common.edit', defaultMessage: 'Edit' }) + ' ' + testPurposeName;
  } else {
    heading = intl.formatMessage({ id: 'testPurpose.addNewTestPurpose', defaultMessage: 'Add New Test Purpose' });
  }

  return (
    <div className={s.testPurpose}>
      {testPurpose.isLoading && <LoadingSpinner />}
      {testPurpose.isRedirect ? <Redirect to={backUrl} /> : ''}
      <Banner
        key={uuid()}
        failureText={messageText}
        showBanner={testPurpose.showBanner}
        status={testPurpose.isOpSuccessful}
        successText={messageText}
      />
      <OperationalSetupContentTemplate selectedPage="testResults" userProfileWidgets={userProfileWidgets}>
        <div className={s.contentWrapper}>
          <div className={s.testPurposeHeader}>
            <GoBack className={s.backLink}>
              &lt; &nbsp;
              <FormattedMessage id="common.back" defaultMessage="BACK" />
            </GoBack>
            <h3>{heading}</h3>
          </div>
          <div className={s.testPurposeContent}>
            <Form>
              <div className={s.topRow}>
                <Row>
                  <Col lg={4}>
                    <Form.Group controlId="formTestPurposeName">
                      <Form.Label>
                        <FormattedMessage id="common.name" defaultMessage="Name" />
                      </Form.Label>

                      <Form.Control
                        type="text"
                        name="Name"
                        onChange={onChange}
                        value={testPurpose.selectedTestPurpose.Name}
                        className={`${s.formControl} ${localformErrors && localformErrors.Name ? s.formControlError : ''}`}
                        placeholder={intl.formatMessage({
                          id: 'common.name',
                          defaultMessage: 'Name'
                        })}
                      />
                      {localformErrors && localformErrors.Name && (
                        <p role="alert" className={s.error}>
                          {localformErrors.Name}
                        </p>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group controlId="formTestPurposeDescription">
                      <Form.Label>
                        <FormattedMessage id="common.description" defaultMessage="Description" />
                      </Form.Label>

                      <Form.Control
                        className={s.textArea}
                        as="textarea"
                        rows="3"
                        name="Description"
                        onChange={onChange}
                        placeholder={intl.formatMessage({
                          id: 'common.description',
                          defaultMessage: 'Description'
                        })}
                        value={testPurpose.selectedTestPurpose.Description}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      variant="primary"
                      className={classNames(s.margin5, s.btnSaveChanges)}
                      onClick={submitForm}
                      noValidate
                      data-unittest="saveData"
                    >
                      <FormattedMessage id="common.save" defaultMessage="SAVE" />
                    </Button>

                    <Button
                      variant="outline-secondary"
                      className={classNames(s.btnCancel)}
                      onClick={cancelHandler}
                      noValidate
                      data-unittest="saveCancel"
                    >
                      <FormattedMessage id="common.cancel" defaultMessage="CANCEL" />
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
        </div>
      </OperationalSetupContentTemplate>
    </div>
  );
};

export default injectIntl(TestPurpose);
